<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="360" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">{{ title }}</v-card-title>

        <v-card-text class="pt-3 pb-8">
          Check your email for the information you need
          to access the Maryland EMS Online Training Center.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dismiss">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    dialog: Boolean,
  },
  methods: {
    dismiss() {
      this.$emit("Close", false);
    },
  },
};
</script>